<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">">
            <template slot="item" slot-scope="props">
              <router-link
                :to="'/'+props.item.to"
                :disabled="props.item.disabled"
                v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
              >{{props.item.text}}</router-link>
            </template>
          </v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn outline color="primary" @click="goBack">
            Go Back
            <v-icon right>arrow_back</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm12 v-if="responseError">
              <span class="red--text">{{responseError}}</span>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                readonly
                :rules="[() => !!queryParams.shopId || 'Shop is required.']"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-menu
                ref="menu"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                :disabled="true"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="queryParams.month"
                    label="From Month"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="queryParams.month" type="month"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
                <v-radio-group v-model="queryParams.balanceType" :mandatory="false" row>
                  <v-radio label="All" value="ALL"></v-radio>
                  <v-radio label="With Balance" value="WITHBALANCE"></v-radio>
                </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <h3 style="margin:0px;color:blue" id="counter">Balance Sheet</h3>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >Shop Code : {{ shopCode }}</p>
            </div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >Date : {{ currentDate }}</p>
            </div>
          </v-flex>
          <br />
          <v-layout row pt-4 ml-4>
            <v-flex xs4>
              <div style="float:left;padding-left:1px">
                <h4 style="margin:0px;color:blue" id="counter">Account Code</h4>
              </div>
            </v-flex>
            <v-flex xs4>
              <div style="float:left;padding-left:1px">
                <h4 style="margin:0px;color:blue" id="counter">Account Name</h4>
              </div>
            </v-flex>
            <v-flex xs4>
              <div style="float:left;padding-left:1px">
                <h4 style="margin:0px;color:blue" id="counter">Total</h4>
              </div>
            </v-flex>
          </v-layout>
          <v-flex xs12 ml-2>
            <div style="width:100%;height:3px;background-color: blue;"></div>
          </v-flex>
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <h4 style="margin:0px;color:blue" id="counter">Assets</h4>
            </div>
          </v-flex>
          <!-- Start non current assets -->
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p style="font-size:13px;margin:0px;font-weight:bold;" id="counter">Non Current Assets</p>
            </div>
          </v-flex>
          <v-data-table
            :items="balanceSheet.balanceSheetAccountList"
            class="elevation-1"
            :loading="showListLoading"
            hide-actions
            :headers="headers"
            item-key="accountId"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.item.sessionName == 'NON_CURRENT_ASSET' && (queryParams.balanceType == 'ALL' ? true : props.item.netBookValue != 0) "
                @click="props.expanded = !props.expanded"
              >
                <td style="width:50px;overflow:hidden">{{ props.item.accountCode }}</td>
                <td style="width:50px;overflow:hidden">{{ props.item.accountName }}</td>
                <td style="width:50px;overflow:hidden;text-align:right">
                  <span
                    v-if="props.item.isSubtract"
                  >({{ props.item.netBookValue | decFormat(6)}})</span>
                  <span v-else>{{ props.item.netBookValue | decFormat(6)}}</span>
                </td>
                <td></td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :items="props.item.balanceSheetDetailList"
                    item-key="props.item.accountId"
                    hide-actions
                    hide-headers
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <tr>
                        <td
                          style="width: calc(100% / 4);overflow:hidden"
                          class="text-xs"
                        >{{ subprops.item.subAccountCode }}</td>
                        <td
                          style="width: calc(100% / 4);overflow:hidden"
                          class="text-xs"
                        >{{ subprops.item.subAccountName }}</td>
                        <td style="width: calc(100% / 4);overflow:hidden;text-align:right" class="text-xs">
                          <span v-if="props.item.nature == subprops.item.nature"
                            style="padding-left:1em"
                          >{{ subprops.item.amount | decFormat(6)}}</span>
                          <span v-else
                            style="padding-left:1em"
                          >({{ subprops.item.amount | decFormat(6)}})</span>
                        </td>
                        <td style="width: calc(100% / 4);overflow:hidden"></td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
            <template slot="footer">
              <td style="font-weight:bold" colspan="2">Total Non Current Assets</td>
              <td
                style="font-weight:bold;text-align:right;"
              >{{ balanceSheet.nonCurrentAssetAmount | decFormat(6)}}</td>
              <td></td>
            </template>
          </v-data-table>
          <!-- End non current assets -->

          <!-- Start current assets -->
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p style="font-size:13px;margin:0px;font-weight:bold;" id="counter">Current Assets</p>
            </div>
          </v-flex>
          <v-data-table
            :items="balanceSheet.balanceSheetAccountList"
            class="elevation-1"
            :loading="showListLoading"
            hide-actions
            :headers="headers"
            item-key="accountId"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.item.sessionName == 'CURRENT_ASSET' && (queryParams.balanceType == 'ALL' ? true : props.item.netBookValue != 0) "
                @click="props.expanded = !props.expanded"
              >
                <td>{{ props.item.accountCode }}</td>
                <td>{{ props.item.accountName }}</td>
                <td style="text-align:right;">
                  <span
                    v-if="props.item.isSubtract"
                  >({{ props.item.netBookValue | decFormat(6)}})</span>
                  <span v-else>{{ props.item.netBookValue | decFormat(6)}}</span>
                </td>
                <td></td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :items="props.item.balanceSheetDetailList"
                    item-key="props.item.accountId"
                    hide-actions
                    hide-headers
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountCode }}</td>
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountName }}</td>
                      <td style="width: calc(100% / 4);overflow:hidden;text-align:right;" class="text-xs">
                        <span v-if="props.item.nature == subprops.item.nature"
                            style="padding-left:1em"
                          >{{ subprops.item.amount | decFormat(6)}}</span>
                          <span v-else
                            style="padding-left:1em"
                          >({{ subprops.item.amount | decFormat(6)}})</span>
                      </td>
                      <td style="width: calc(100% / 4);overflow:hidden"></td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
            <template slot="footer">
              <td style="font-weight:bold" colspan="2">Total Current Assets</td>
              <td
                style="font-weight:bold;text-align:right;"
              >{{ balanceSheet.currentAssetAmount | decFormat(6)}}</td>
              <td></td>
            </template>
          </v-data-table>
          <!-- End current assets -->
          <v-flex xs12 ps-1 pe-1>
            <v-layout row style="background: rgba(128, 128, 128, 0.5);">
              <v-flex xs4 ml-2>
                <div style="float:left;padding-left:11px">
                  <h4 style="margin:0px;font-weight:bold;" id="counter">Total Assets</h4>
                </div>
              </v-flex>
              <v-flex xs4>
                <div style="float:left;padding-left:11px">
                  <h4 style="margin:0px;color:blue" id="counter"></h4>
                </div>
              </v-flex>
              <v-flex xs4 ml-4>
                <div style="float:left;padding-left:15px">
                  <h4
                    style="margin:0px;font-weight:bold;"
                    id="counter"
                  >{{ balanceSheet.totalAssetAmount | decFormat(6) }}</h4>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout row pt-4 ml-4>
            <v-flex xs4>
              <div style="float:left;padding-left:5px">
                <h4 style="margin:0px;color:blue" id="counter">LIABILITIES + EQUITY</h4>
              </div>
            </v-flex>
            <v-flex xs4>
              <div style="float:left;padding-left:1px">
                <h4 style="margin:0px;color:blue" id="counter"></h4>
              </div>
            </v-flex>
            <v-flex xs4>
              <div style="float:left;padding-left:1px">
                <h4 style="margin:0px;color:blue" id="counter">MMK</h4>
              </div>
            </v-flex>
          </v-layout>
          <v-flex xs12 ml-2>
            <div style="width:100%;height:3px;background-color: blue;"></div>
          </v-flex>

          <!-- Start Equity -->
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p style="font-size:13px;margin:0px;font-weight:bold;" id="counter">Equity</p>
            </div>
          </v-flex>
          <v-data-table
            :items="balanceSheet.balanceSheetAccountList"
            class="elevation-1"
            :loading="showListLoading"
            hide-actions
            :headers="headers"
            item-key="accountId"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.item.sessionName == 'EQUITY' && (queryParams.balanceType == 'ALL' ? true : props.item.netBookValue != 0) "
                @click="props.expanded = !props.expanded"
              >
                <td>{{ props.item.accountCode }}</td>
                <td>{{ props.item.accountName }}</td>
                <td style="text-align:right;">
                  <span
                    v-if="props.item.isSubtract"
                  >({{ props.item.netBookValue | decFormat(6)}})</span>
                  <span v-else>{{ props.item.netBookValue | decFormat(6)}}</span>
                </td>
                <td></td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :items="props.item.balanceSheetDetailList"
                    item-key="props.item.accountId"
                    hide-actions
                    hide-headers
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountCode }}</td>
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountName }}</td>
                      <td style="width: calc(100% / 4);overflow:hidden;text-align:right;" class="text-xs">
                        <span v-if="props.item.nature == subprops.item.nature"
                            style="padding-left:1em"
                          >{{ subprops.item.amount | decFormat(6)}}</span>
                          <span v-else
                            style="padding-left:1em"
                          >({{ subprops.item.amount | decFormat(6)}})</span>
                      </td>
                      <td style="width: calc(100% / 4);overflow:hidden"></td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
            <template slot="footer">
              <td class="font-weight-black" colspan="2">Total Equity</td>
              <td
                class="font-weight-black" style="text-align:right;"
              >{{ balanceSheet.equityAmount | decFormat(6)}}</td>
              <td></td>
            </template>
          </v-data-table>
          <!-- End Equity -->

          <!-- Start Current Liabilities -->
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >Current Liabilities</p>
            </div>
          </v-flex>
          <v-data-table
            :items="balanceSheet.balanceSheetAccountList"
            class="elevation-1"
            :loading="showListLoading"
            hide-actions
            :headers="headers"
            item-key="accountId"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.item.sessionName == 'CURRENT_LIABILITIES' && (queryParams.balanceType == 'ALL' ? true : props.item.netBookValue != 0) "
                @click="props.expanded = !props.expanded"
              >
                <td>{{ props.item.accountCode }}</td>
                <td>{{ props.item.accountName }}</td>
                <td style="text-align:right">
                  <span
                    v-if="props.item.isSubtract"
                  >({{ props.item.netBookValue | decFormat(6)}})</span>
                  <span v-else>{{ props.item.netBookValue | decFormat(6)}}</span>
                </td>
                <td></td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :items="props.item.balanceSheetDetailList"
                    item-key="props.item.accountId"
                    hide-actions
                    hide-headers
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountCode }}</td>
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountName }}</td>
                      <td style="width: calc(100% / 4);overflow:hidden;text-align:right;" class="text-xs">
                        <span v-if="props.item.nature == subprops.item.nature"
                            style="padding-left:1em"
                          >{{ subprops.item.amount | decFormat(6)}}</span>
                          <span v-else
                            style="padding-left:1em"
                          >({{ subprops.item.amount | decFormat(6)}})</span>
                      </td>
                      <td style="width: calc(100% / 4);overflow:hidden"></td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
            <template slot="footer">
              <td class="font-weight-black" colspan="2">Total Current Liabilities</td>
              <td
                class="font-weight-black" style="text-align:right;"
              >{{ balanceSheet.currentLiabilitiesAmount | decFormat(6)}}</td>
              <td></td>
            </template>
          </v-data-table>
          <!-- End Current Liabilities -->

          <!-- Start Non Current Liabilities -->
          <v-flex xs12 ml-2 pt-4>
            <div style="float:left;padding-left:11px">
              <p
                style="font-size:13px;margin:0px;font-weight:bold;"
                id="counter"
              >Non Current Liabilities</p>
            </div>
          </v-flex>
          <v-data-table
            :items="balanceSheet.balanceSheetAccountList"
            class="elevation-1"
            :loading="showListLoading"
            hide-actions
            :headers="headers"
            item-key="accountId"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr
                v-if="props.item.sessionName == 'NON_CURRENT_LIABILITIES' && (queryParams.balanceType == 'ALL' ? true : props.item.netBookValue != 0) "
                @click="props.expanded = !props.expanded"
              >
                <td>{{ props.item.accountCode }}</td>
                <td>{{ props.item.accountName }}</td>
                <td style="text-align:right;">
                  <span
                    v-if="props.item.isSubtract"
                  >({{ props.item.netBookValue | decFormat(6)}})</span>
                  <span v-else>{{ props.item.netBookValue | decFormat(6)}}</span>
                </td>
                <td></td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card class="elevation-1">
                <v-card-text>
                  <v-data-table
                    :items="props.item.balanceSheetDetailList"
                    item-key="props.item.accountId"
                    hide-actions
                    hide-headers
                    class="elevation-10"
                  >
                    <template slot="items" slot-scope="subprops">
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountCode }}</td>
                      <td
                        style="width: calc(100% / 4);overflow:hidden"
                        class="text-xs"
                      >{{ subprops.item.subAccountName }}</td>
                      <td style="width: calc(100% / 4);overflow:hidden;text-align:right;" class="text-xs">
                        <span v-if="props.item.nature == subprops.item.nature"
                            style="padding-left:1em"
                          >{{ subprops.item.amount | decFormat(6)}}</span>
                          <span v-else
                            style="padding-left:1em"
                          >({{ subprops.item.amount | decFormat(6)}})</span>
                      </td>
                      <td style="width: calc(100% / 4);overflow:hidden"></td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </template>
            <template slot="footer">
              <td class="font-weight-black" colspan="2">Total Non Current Liabilities</td>
              <td
                class="font-weight-black" style="text-align:right;"
              >{{ balanceSheet.nonCurrentLiabilitiesAmount | decFormat(6)}}</td>
              <td></td>
            </template>
          </v-data-table>
          <!-- End Non Current Liabilities -->
          <v-flex xs12 ps-1 pe-1>
            <v-layout row style="background: rgba(128, 128, 128, 0.5);">
              <v-flex xs4 ml-2>
                <div style="float:left;padding-left:11px">
                  <h4 style="margin:0px;font-weight:bold;" id="counter">Total Liabilities + Equity</h4>
                </div>
              </v-flex>
              <v-flex xs4>
                <div style="float:left;padding-left:11px">
                  <h4 style="margin:0px;color:blue" id="counter"></h4>
                </div>
              </v-flex>
              <v-flex xs4 ml-4>
                <div style="float:left;padding-left:5px;text-align:right;">
                  <h4
                    style="margin:0px;font-weight:bold;"
                    id="counter"
                  >{{ balanceSheet.liaEquaAmount | decFormat(6) }}</h4>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex sm12>
        <div class="text-xs-center">
          <v-btn color="primary" :loading="saveLoading" @click="printInvoice('balanceSheetPrint')">
            Print
            <v-icon right>save</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>

    <!-- BS print hidden area -->
    <div id="balanceSheetPrint" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center;padding-bottom:5px">
        <p
          style="font-size:15px;margin:0px;font-weight:bold;"
          v-if="balanceSheet.shop"
        >{{ balanceSheet.shop.name }}</p>
      </div>

      <div style="text-align:center">
        <p
          style="font-size:15px;margin:0px"
        >Statement Of Financial Position</p>
      </div>
      <div style="float:left;padding-left:11px">
        <p style="font-size:15px;margin:0px" id="counter">Balance Sheet Code : {{balanceSheet.code}}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter"></p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
          v-if="balanceSheet.shop"
        >Shop Code: {{ balanceSheet.shop.code }}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p
          style="font-size:15px;margin:0px"
          id="counter"
        >Created Date : {{ balanceSheet.createdDateInMilliSeconds | format-ms-date }}</p>
      </div>
      <br />
      <div style="float:left;padding-left:11px">
        <p style="font-size:15px;margin:0px" id="casher">Date : {{ balanceSheet.year }}, {{ balanceSheet.month }}</p>
      </div>
      <div style="float:right;padding-right:11px">
        <p style="font-size:15px;margin:0px" id="counter">Created By : {{balanceSheet.createdBy}}</p>
      </div>
      <br />

      <div style="clear:both"></div>
      <div style="height:10px"></div>
      <div style="padding-left:5px;padding-right:5px">
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr style="line-height: 20px;">
              <th style="border:1px solid black;text-align:center">Account Code</th>
              <th style="border:1px solid black;text-align:center">Account Name</th>
              <th style="border:1px solid black;text-align:center">SubAccount Amount</th>
              <th style="border:1px solid black;text-align:center">Amount</th>
              <th style="border:1px solid black;text-align:center">Total Amount</th>
            </tr>
          </thead>
          <!-- start non current asset -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >NON CURRENT ASSET</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'a'+index">
            <tbody  v-if="item.sessionName == 'NON_CURRENT_ASSET' && (queryParams.balanceType == 'ALL' ? true : item.netBookValue != 0) ">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'ad'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:center"></td>
                <td style="border:1px solid black;text-align:center"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Non Current Assets</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.nonCurrentAssetAmount | decFormat(6)}}</td>
          </tr>
          <!-- end non current asset -->
          <!-- start current asset -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >CURRENT ASSET</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'b'+index">
            <tbody v-if="item.sessionName == 'CURRENT_ASSET' && (queryParams.balanceType == 'ALL' ? true : item.netBookValue != 0) ">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'bd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:center"></td>
                <td style="border:1px solid black;text-align:center"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Current Assets</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.currentAssetAmount | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Assets</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.currentAssetAmount+balanceSheet.nonCurrentAssetAmount | decFormat(6)}}</td>
          </tr>
          <!-- end current asset -->
          <!-- start equity -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >EQUITY</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'i'+index">
            <tbody v-if="item.sessionName == 'EQUITY' && (queryParams.balanceType == 'ALL' ? true : item.netBookValue != 0) ">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'id'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:center"></td>
                <td style="border:1px solid black;text-align:center"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Equity</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.equityAmount | decFormat(6)}}</td>
          </tr>
          <!-- end equity -->
          <!-- start current liabilities -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >CURRENT LIABILITIES</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'c'+index">
            <tbody v-if="item.sessionName == 'CURRENT_LIABILITIES' && (queryParams.balanceType == 'ALL' ? true : item.netBookValue != 0) ">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'cd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
                <td style="border:1px solid black;text-align:right"></td>
                <td style="border:1px solid black;text-align:right"></td>
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Current Liabilities</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.currentLiabilitiesAmount | decFormat(6)}}</td>
          </tr>
          <!-- end current liabilities -->
          <!-- start non current liabilities -->
          <tr style="line-height: 20px;">
            <td
              colspan="5"
              style="border:1px solid black;text-align:left;font-weight:bold;"
            >NON CURRENT LIABILITIES</td>
          </tr>
          <tbody v-for="(item, index) in balanceSheet.balanceSheetAccountList" :key="'d'+index">
            <tbody v-if="item.sessionName == 'NON_CURRENT_LIABILITIES' && (queryParams.balanceType == 'ALL' ? true : item.netBookValue != 0) ">
            <tr style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{item.accountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.isSubtract">({{item.netBookValue | decFormat(6)}})</span>
                <span v-else>{{item.netBookValue | decFormat(6)}}</span>
              </td>
              <td style="border:1px solid black;text-align:right"></td>
            </tr>
            <tr  v-for="(itemdetail, i) in item.balanceSheetDetailList" :key="'dd'+i" style="line-height: 20px;">
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountCode}}</span>
              </td>
              <td style="border:1px solid black;text-align:left">
                <span>{{itemdetail.subAccountName}}</span>
              </td>
              <td style="border:1px solid black;text-align:right">
                <span v-if="item.nature == itemdetail.nature">{{itemdetail.amount | decFormat(6)}}</span>
                <span v-else>({{itemdetail.amount | decFormat(6)}})</span>
                </td>
              <td style="border:1px solid black;text-align:center"></td>
              <td style="border:1px solid black;text-align:center"></td>  
            </tr>
            </tbody>
          </tbody>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Non-Current Liabilities</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.nonCurrentLiabilitiesAmount | decFormat(6)}}</td>
          </tr>
          <tr style="line-height: 20px;">
            <td
              colspan="4"
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >Total Liabilities And Equity</td>
            <td
              style="border:1px solid black;text-align:right;font-weight:bold;"
            >{{balanceSheet.liaEquaAmount | decFormat(6)}}</td>
          </tr>
          <!-- end non current liabilities -->
        </table>
        <div style="height:10px"></div>
      </div>
    </div>

    <!-- End print  -->
  </v-container>
</template>
<script>
import { balanceSheetService } from "../../services/balance-sheet-service";
import { shopService } from "../../services/shop-service";
import { BalanceSheet } from "../../models/model";
import { commonService } from "../../services/common-service";
export default {
  name: "BalanceSheetDetail",
  components: {},
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Balance Sheet",
        disabled: true,
      },
      {
        text: "Balance Sheet Detail",
        disabled: true,
      },
    ],
    queryParams: {
      shopId: "",
      month: new Date().toISOString().substr(0, 7),
      balanceType: 'ALL'
    },
    currentDate: new Date().toISOString().slice(0, 10),
    responseError: "",
    saveLoading: false,
    shopCode: "",
    shopList: [],
    balanceSheet: new BalanceSheet(),
    oldBalanceSheet: new BalanceSheet(),
    previewFilterObj: new BalanceSheet(),
    decimalFormat: "",
    menu: false,
    date: new Date(),
    headers: [
      { text: "Account Code", sortable: false, width: "1%" },
      { text: "Account Name", sortable: false, width: "1%" },
      { text: "Total", sortable: false, width: "1%", align: "right" },
      { text: "", sortable: false, width: "1%" }
    ],
  }),

  created() {
    //for deep linking
    const id = this.$route.params.id;
    if (id == "new") {
      // new BalanceSheet
    } else {
      this.getBalanceSheetDetail(id);
    }
    this.decimalFormat = commonService.formatdecimal();
    this.getShopList();
  },
  methods: {
    getBalanceSheetDetail(id) {
      balanceSheetService.getBalanceSheetById(id).then((res) => {
        this.balanceSheet = res.data;
        this.shopCode = this.balanceSheet.shop.code;
        this.queryParams.shopId = this.balanceSheet.shopId;
        let date = new Date(
          this.balanceSheet.month + " 2 " + this.balanceSheet.year
        );
        this.queryParams.month = date.toISOString().substr(0, 7);
        this.oldBalanceSheet = JSON.parse(JSON.stringify(res.data));
      });
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    goBack() {
      this.$router.push("/balance-sheets");
    },

    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },
  },
};
</script>